module.exports = __webpack_public_path__ + "static/media/e-tax-logo.8b504817.svg";